import { createActions } from 'redux-actions';
import { GetInsurancePolicyUserParams } from '@apis/InsurancePolicyUserApi';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';
import { BenefitLimit } from '@models/BenefitLimit';

export type State = {
  policyUser?: InsurancePolicyUser | null;
  healthBenefitLimitsWithAccumulatedPaidAmounts?: BenefitLimit[] | null;
};

export type InsurancePolicyUserFetchPayload = GetInsurancePolicyUserParams;
export type InsurancePolicyUserHealthBenefitLimitsFetchPayload = GetInsurancePolicyUserParams;
export type StateUpdatePayload = Partial<State>;

export const {
  insurancePolicyUserFetch,
  insurancePolicyUserHealthBenefitLimitsFetch,
  stateUpdate,
} = createActions(
  'INSURANCE_POLICY_USER_FETCH',
  'INSURANCE_POLICY_USER_HEALTH_BENEFIT_LIMITS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_INSURANCE_POLICY_USER_DETAILS_PAGE',
  },
);
